import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";
import { MedicinService } from '../services/index';
import { map } from "rxjs/operators";
@Component({
  selector: 'app-home-accordian',
  templateUrl: './home-accordian.component.html',
  styleUrls: ['./home-accordian.component.scss']
})
export class HomeAccordianComponent implements OnInit {
  constructor(public ms: MedicinService) { }
  public faqData: any = [
    {
      "Question": "Why do I need the NuLifeSpan Rx discount card?",
      "Answer": "The cost of prescription drugs can vary widely between pharmacies due to less regulation than you might expect, with differences sometimes surpassing $100. Additionally, insurance coverage for medications has diminished significantly over the past decade, with insurers passing 30-75% more of the drug costs onto patients.<br/>The NuLifeSpan Rx discount card is designed to help you navigate these challenges by offering substantial discounts and cashback on a wide range of prescriptions, making your healthcare expenses more manageable."
    },
    {
      "Question": "Is the NuLifeSpan Rx discount program really free?",
      "Answer": "Absolutely! The NuLifeSpan Rx prescription discount program is completely free to use. There are no hidden charges, such as membership fees or sign-up fees, and no eligibility requirements. Enjoy saving on your prescriptions without any cost."
    },
    {
      "Question": "How can I get my an NuLifeSpan Rx discount card?",
      "Answer": "You can choose from two convenient options:<br/>1. Personalized Discount Card: Sign up at our website to receive your personalized NuLifeSpan Rx discount card. This option not only offers discounts but also allows you to earn cashback on eligible prescriptions. You can download, print, or add this card to your phone's wallet for easy access.<br/>2. Generic Card: If you prefer not to sign up, use our generic discount card available here. While you'll enjoy the same discounts on prescriptions, cashback rewards are exclusive to personalized cardholders. This card can also be downloaded, printed, or added to your phone's wallet.<br/>Both options provide significant savings on your prescriptions with NuLifeSpan Rx."
    },
    {
      "Question": "How does the NuLifeSpan Rx prescription discount program work?",
      "Answer": "It's easy!<br/>1. Get Your Card: Sign up to get your free NuLifeSpan Rx Discount Card at www.nulifespanrx.com or use our free generic card.<br/>2. Compare Prices: Use our website to find the lowest prices on your prescription at pharmacies near you.<br/>3. Get Discounts: Show your card at the pharmacy to apply your discount and cashback instantly."
    },
    {
      "Question": "How much cashback can I earn on my prescription purchases?",
      "Answer": "With every eligible transaction using your NuLifeSpan Rx discount card, you'll earn $1.50 cashback. Eligible transactions include any discounted prescription medication purchases made by you, your friends, or your family with the card. It's important to note that if the regular price of a prescription is lower than our discounted price and you choose not to use your NuLifeSpan Rx discount card, that purchase will not qualify for cashback."
    },
    {
      "Question": "Can I share my card with family and friends?",
      "Answer": "Absolutely, we encourage it! Feel free to print out copies of your NuLifeSpan Rx card or snap a picture to share with your friends and family. By spreading the word, you're helping your loved ones save on their prescriptions too. You'll also earn cashback on those purchases!"
    },
    {
      "Question": "Does the card work on pet prescriptions?",
      "Answer": "Yes it does!<br/>We recognize that pets are important family members, too. That's why our NuLifeSpan Rx Discount Card can be used to save on prescriptions for your pets as well as for yourself. Just have your veterinarian write a prescription for your pet, and present it along with your discount card at a participating pharmacy to enjoy the savings."
    },
    {
      "Question": "Is the NuLifeSpan Rx prescription discount program Insurance?",
      "Answer": "No, the NuLifeSpan Rx prescription discount program is not insurance. It's a discount program designed to help you save on prescriptions. It does not meet the coverage requirements of the Affordable Care Act or any other health insurance mandates."
    },
    {
      "Question": "Do I have to show my card at the pharmacy every time?",
      "Answer": "Yes, to ensure you receive your discount, you must show your NuLifeSpan Rx card to the pharmacist with every purchase. You have the flexibility to download the card to your phone wallet, save it as a PDF, or even print it out."
    },
    {
      "Question": "Are over-the-counter medications covered?",
      "Answer": "The NuLifeSpan Rx discounts apply exclusively to prescription medications. However, certain over-the-counter drugs that are available in prescription-strength forms, like ibuprofen, may be eligible for discounts if prescribed by a healthcare professional."
    },
    {
      "Question": "If I have insurance and/or Medicare, can I still use the NuLifeSpan Rx card?",
      "Answer": "Absolutely! The NuLifeSpan Rx prescription discount program can be a great option even if you have Medicare or other insurance, especially in situations where:<br/>- Our prices are lower than your typical co-pays.<br/>- Your insurance does not cover a specific drug.<br/>- High deductibles make your medication unaffordable.<br/>Important: Using the NuLifeSpan Rx price won't count towards your insurance deductible, out-of-pocket maximums, or the Medicare 'donut hole' since the discount is applied instead of your insurance or Medicare benefits."
    },
    {
      "Question": "Which pharmacy offers the cheapest price for my prescription?",
      "Answer": "You can use our pricing tool the find the nearest pharmacy that offers the cheapest price for your prescriptions."
    },
    {
      "Question": "Can I share my card with family and friends?",
      "Answer": "Absolutely, we encourage it! Feel free to print out copies of your NuLifeSpan Rx card or snap a picture to share with your friends and family. By spreading the word, you're helping your loved ones save on their prescriptions too. You'll also earn cashback on those purchases!"
    },
    {
      "Question": "How do I cashout my rewards?",
      "Answer": "Cashout is simple and automatic. Once a month, if your cashback balance exceeds $25, we directly deposit your rewards into your bank account, provided you've set up your payout details.<br/>To add your bank information, log in to your NuLifeSpan Rx account, navigate to your summary page, and click 'Get Paid.' You’ll be guided to enter and save your bank details.<br/>Rest assured, your banking information is securely transmitted to our payment partner, Wise, and is not stored on our systems. For more on security and privacy, visit Wise’s website, at www.wise.com, to review their terms and conditions and privacy policy."
    }
  ]
  public collapse: any;
  ngOnInit() {
    // this.GetFaq();
  }

  GetFaq() {
    this.ms.GetFaq().pipe(map(res => res.json()))
      .subscribe(data => {
        if (data.length > 0) {
          console.log(data)
          this.faqData = JSON.parse(data);
        }
        else {
          //error
        }
      });
  }
  toggleCollapse(val) {
    $('.panel-collapse').removeClass('show');
    let idSet = '#' + val;
    let collapseSet = '#collapse' + val;
    let expandedValue = $(idSet).attr('aria-expanded');
    if (expandedValue == 'true') {
      $(idSet).attr('aria-expanded', 'false');
      $(collapseSet).removeClass('show');
    } else {
      $(".removeAttr").attr('aria-expanded', 'false');
      $(idSet).attr('aria-expanded', 'true');
      $(collapseSet).addClass('show');
    }
  }
}